module.exports = __webpack_public_path__ + "img/Bandeau2.1c5db30a.png";